<template>
    <div class="main-content">
        <div class="action-area">
            <slot name="action-area">
            </slot>
        </div>
        <div class="content-area">
            <slot>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainContent',
    props: {}
};
</script>
